<div class="commande" [ngClass]="{'add-bag':activestep==2}">
        <div class="container">
            <div class="card-header">
                <ul class="nav">
                    <li class="nav-item deco" [ngClass]="{on:activestep>=1}" (click)="goTostep(1)">
                        <span class="title">RÉCAPITULATIF</span>
    
                    </li>
                    <li class="nav-item deco" [ngClass]="{on:activestep>=2}" (click)="goTostep(2)" *ngIf="!isAuthenticated">
                        <span class="deco"></span>
                        <span class="title">CONNEXION</span>
    
                    </li>
                    <li class="nav-item deco" [ngClass]="{on:activestep==3}" (click)="goTostep(3)">
                        <span class="deco"></span>
                        <span class="title">CONFIRMATION</span>
                    </li>
                </ul>
            </div>
            <summary *ngIf="activestep==1" (onNext)="next()"></summary>
            <div class="signin">
                <checkout-authentification *ngIf="activestep==2" (onNext)="next()" (onBack)="back(1)"></checkout-authentification>
            </div>
            <confirmation *ngIf="activestep==3" (onBack)="back(2)"></confirmation>
        </div>
    </div>